import React from 'react'
import { Redirect } from 'react-router-dom'

export const ReturnPage: React.FC = () => (
  <Redirect to={`/centrum${window.location.search}`} />
)
